import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message as msg } from "antd";
import { Button, Form } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getHoleOutRule, initRule, updateHoleOutRule } from "../../features/hole-out-rule/holeOutRuleSlice";

const HoleOutRule = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { holeOutRule, isError, updating, message, isUpdateSuccess } = useSelector(
    (state) => state.holeOutRule
  );

  useEffect(() => {
    dispatch(initRule());
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }
    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Hole out rule is updated successfully",
      });
    }

    dispatch(getHoleOutRule());
  }, [isError, message, messageApi, dispatch, isUpdateSuccess]);

  /** Set default values in form */
  useEffect(() => {
    if (holeOutRule) {
      form.setFieldsValue({
        content: holeOutRule?.content || "",
      });
    }
  }, [holeOutRule, form]);

  /** On submit call api */
  const onFinish = (values) => {
    const convertedValues = {
      ...values,
    };
    dispatch(updateHoleOutRule(convertedValues));
  };

  /** If there is error on form submission */
  const onFinishFailed = (errorInfo) => {
    messageApi.open({
      type: "error",
      content: errorInfo.message || "Error on form submission",
    });
  };
  return (
    <>
      {contextHolder}
      <div>
        <h3 className="mb-4 title">Hole Out Rule</h3>
        <div className="d-flex gap-3">
          <div className="d-flex flex-grow-1 bg-white p-3 roudned-3">
            <div className="p-4 bg-white rounded-3" style={{ width: "100%" }}>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                initialValues={{}}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  name="content"
                >
                  <ReactQuill
                    theme="snow"
                    style={{ height: "250px", marginBottom: "40px" }}
                  />
                </Form.Item>

                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                >
                  <Button disabled={updating} type="primary" htmlType="submit">
                    {updating ? "Update ..." : "Update"}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HoleOutRule;
